<template>
  <div class="lms-index-pills" role="tablist" aria-label="Status filters">
    <button
      v-for="name in names"
      :key="name"
      type="button"
      class="lms-index-pills__chip"
      :class="{ 'is-active': name === active }"
      role="tab"
      :aria-selected="name === active"
      @click="$emit('select', name)"
    >
      <span class="lms-index-pills__label">{{ name }}</span>
      <span class="lms-index-pills__count">{{ counts[name] ?? 0 }}</span>
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  counts: { type: Object, default: () => ({}) },
  active: { type: String, default: 'All' }
})
defineEmits(['select'])

const names = computed(() => Object.keys(props.counts || {}))
</script>

<style scoped>
.lms-index-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.lms-index-pills__chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--lms-border);
  background: var(--app-surface);
  color: var(--lms-text);
  border-radius: 999px;
  padding: 6px 12px 6px 14px;
  font-family: 'Source Sans 3', sans-serif;
  font-size: 0.8125rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 160ms ease, background 160ms ease, color 160ms ease, transform 160ms ease;
}

.lms-index-pills__chip:hover {
  border-color: rgba(11, 126, 164, 0.45);
  transform: translateY(-1px);
}

.lms-index-pills__chip.is-active {
  background: rgba(11, 126, 164, 0.1);
  border-color: var(--lms-primary);
  color: var(--lms-primary-dark);
}

.lms-index-pills__count {
  min-width: 1.5rem;
  padding: 1px 7px;
  border-radius: 999px;
  background: rgba(11, 126, 164, 0.12);
  color: var(--lms-primary-dark);
  font-variant-numeric: tabular-nums;
  font-size: 0.75rem;
}

.lms-index-pills__chip.is-active .lms-index-pills__count {
  background: var(--lms-primary);
  color: #fff;
}
</style>
